<ul class="layout-menu">
  <ng-container *ngFor="let item of skeletons;">
    <li>
      <p-skeleton width="7.4rem" height="5rem"></p-skeleton>
    </li>
    <li class="menu-separator"></li>
  </ng-container>
    <ng-container *ngFor="let item of model; let i = index;">
      <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true" [ngClass]="{'active': item.active}"></li>
      <li *ngIf="item.separator" class="menu-separator" [ngClass]="{'active': item.active}"></li>
    </ng-container>
  </ul>
